import { Box, Divider } from '@atgfr8/atg-ui-tailwind';
import { Button } from '@components';
import { useNavigate } from '@solidjs/router';
import { PendingApprovals } from '@store/Global/types';
import { AlertIcon } from '@atgfr8/icons';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { formatDateString } from '@utils/dateFormat';
import { routeOrderDetails } from '@utils/routeOrderDetails';
import { isEmpty } from 'lodash';
import { Accessor, Show } from 'solid-js';

type Props = {
  overdueApprovalsData: Accessor<PendingApprovals[]>;
};

const OverdueApprovalsWarning = (props: Props) => {
  const navigate = useNavigate();
  const checkApprovals = () => {
    sessionStorage.setItem('snoozedApprovals', new Date().getTime().toString());
    window.location.reload();
  };
  return (
    <Show when={!isEmpty(props.overdueApprovalsData())}>
      <Box
        class={
          'border-[#ebccd1] flex px-4 py-2 rounded-md my-2 border-2 rounded-5 shadow-md bg-[#f2dede] max-h-[calc(100vh-200px)]'
        }
        style={{
          'box-shadow': '0px 8px 5px rgba(0, 0, 0, 0.16)',
          'margin-left': '0.2em',
          'margin-right': '0.2em',
        }}
      >
        <div style={{ width: '-webkit-fill-available' }} class="flex-1">
          <div
            style={{
              display: 'flex',
              'justify-content': 'center',
              'align-items': 'center',
              margin: '0',
              cursor: 'pointer',
            }}
          >
            <AlertIcon style={{ 'font-size': '24px', color: '#a94442' }} />
            <span
              style={{
                'font-size': '20px',
                'user-select': 'none',
                color: '#a94442',
              }}
            >
              You have Overdue Approvals that have not been addressed. Please
              address these to unlock your loadboard.
            </span>
          </div>
          <Divider class="m-[5px]!" sx={{ 'background-color': '#e4b9c0' }} />
          <div class="text-sm text-[#a94442] font-medium mt-2">
            You must address the following overdue approval items to unlock your
            board:{' '}
          </div>
          <Box class="overflow-y-auto h-[calc(100%-108px)]!">
            {props.overdueApprovalsData().map((item) => (
              <Box
                class="bg-[#d9edf7] border-[#bce8f1] p-3 text-[#31708f] mb-1 rounded-md cursor-pointer"
                onClick={() => {
                  const isNative = routeOrderDetails(item.order);
                  if (isNative) {
                    navigate(`/order/details/${item.order}`);
                  }
                }}
              >
                <strong>{item.order}</strong> - {item.description}
                {Boolean(item.lastComment) && (
                  <div>
                    {item.lastComment}
                    {(Boolean(item.lastCommentBy) ||
                      Boolean(item.lastCommentDate)) && (
                      <>
                        {' '}
                        - {item.lastCommentBy}{' '}
                        {formatDateString(item.lastCommentDate)}
                      </>
                    )}
                  </div>
                )}
              </Box>
            ))}
          </Box>
          <Box class="flex justify-center mt-2">
            <Button
              variant="contained"
              color="primary"
              label="Unlock my Loadboard"
              onClick={checkApprovals}
              dataTestId={formatDataTestId('Unlock my Loadboard', 'button')}
            />
          </Box>
        </div>
      </Box>
    </Show>
  );
};

export default OverdueApprovalsWarning;
